import Config from "@/const/Config";
import { ShinseiOption } from "@/types/Option";
import { BaseApi } from "./BaseApi";
import { OperationSupportLog } from "@/types/OperationSupport";

export class OperationSupportApi extends BaseApi {
  API_PREFIX = '/operation_support/'

  /**
   * 運用支援ログをDBに記録します
   */
  public async saveLog(logData: OperationSupportLog): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + this.API_PREFIX + 'save_log', { logData })
      return res.data
    } catch (e: any) {
      throw e
    }
  }


}